import { getPartsOfValue } from './common.js';

var transformLogicalBlockProperty = function transformLogicalBlockProperty(properties) {
  return function (value) {
    var valuesSplit = getPartsOfValue(value);
    var propertiesWithValues = [];
    if (valuesSplit.length === 1) {
      properties.forEach(function (property) {
        return propertiesWithValues.push("".concat(property, ": ").concat(value, ";"));
      });
    } else if (valuesSplit.length === 2) {
      properties.forEach(function (property, index) {
        return propertiesWithValues.push("".concat(property, ": ").concat(valuesSplit[index], ";"));
      });
    }
    return {
      base: propertiesWithValues.join("")
    };
  };
};

export { transformLogicalBlockProperty };
